module.exports = __webpack_public_path__ + "static/media/18.b74a246a.mp3";